import { Button } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { useReviewSaveButtonContext } from './ReviewSaveButtonContext'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 16px;
  background: white;

  > div {
    max-width: 608px;
    margin: auto;
  }
`

export type ReviewSaveButtonProps = {
  totalSteps: number
  currentStepIndex: number
  changeStep: (step: number) => void
  submitButton?: string
}

export default function ReviewSaveButton({
  totalSteps,
  currentStepIndex,
  changeStep,
  submitButton
}: ReviewSaveButtonProps) {
  const { t } = useTranslation()
  const { stickySaveVisible } = useReviewSaveButtonContext()

  if (!stickySaveVisible || totalSteps !== currentStepIndex) {
    return null
  }

  const onSave = () => changeStep(totalSteps + 1)

  return (
    <Wrapper>
      <div>
        <Button onClick={onSave} impactClass='situationChange'>
          {submitButton || t('step.review.submit_button')}
        </Button>
      </div>
    </Wrapper>
  )
}
